import { createPortal } from 'react-dom';
import { Disclosures } from '@/components/Disclosures';
import { useHasMounted } from '@/hooks/useHasMounted';
import { getDisclosureGroups } from './getDisclosureGroups';

const detailsPortal = document.querySelector('.product__secondary > div');

const detailsNode = document.querySelector('.product__secondary__content');

const { expandedKeys, groups } = getDisclosureGroups(detailsNode?.childNodes);

export const useProductDetails = () => {
  const hasMounted = useHasMounted(() => {
    if (detailsPortal && detailsNode && hasMounted) {
      detailsNode.parentNode?.removeChild(detailsNode);
    }
  });

  return detailsPortal?.firstChild
    ? createPortal(
        <Disclosures expandedKeys={expandedKeys} groups={groups} />,
        detailsPortal,
      )
    : null;
};
